module.exports = __webpack_public_path__ + "media/img/features/preliminary-step-d92e9351543b655b9aa0e5d56148db32.gif";